import * as React from 'react';
import * as about from "./style.module.scss";
import * as licenses from "../../../../Licenses/licenses.module.scss";
import { CarouselFullscreen } from '../../../../CarouselFullscreen';
import licensesData from './licenses.json';

export const About = () => {
  const [fullScreenState, setFullScreenState] = React.useState({ open: false, selectedSlideIndex: 0 });
  return (
    <section className={about.about}>
      <div className="container">
        <div className={about.about__wrapper}>
          <div className={about.about__content}>
            <h4>Центр образовательных технологий Advance — лидер в развитии навыков ускоренного обучения у детей и
              взрослых.</h4>
            <div className={about.about__text}>
              <p>В наших программах применяются авторские технологии развития когнитивных способностей, памяти,
                внимания, интеллектуальной выносливости, а также навыка самостоятельного обучения. </p>
              <p>Курсы Advance помогают учиться и работать в 2–6 раз эффективнее и делать это с удовольствием.</p>
            </div>
            <div className={about.about__docs}>
              <div className={about.about__docsImgs}>
                {licensesData.map((elem, index) => (
                  <div key={index}>
                    <button
                      className={licenses.licenses__imgBlock}
                      onClick={() => {
                        setFullScreenState({ open: true, selectedSlideIndex: index });
                      }}
                    >
                      <span className={licenses.licenses__zoomIn}></span>
                      <img src={elem.imageSrc} alt={elem.title} className={licenses.licenses__img} />
                    </button>
                  </div>
                ))}
              </div>
              <p>Лицензии Advance на осуществление образовательной деятельности</p>
            </div>
          </div>
          <img
            src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/big-rocket.svg"
            alt=""
            className={about.about__rocket}
          />
        </div>
        <div className={about.about__blocks}>
          <div className={about.about__block}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/cot-asi.png" alt=""/>
              <p>Advance входит в список <strong>«100 лидеров новых подходов в образовании»</strong> и в перечень
                проектов, поддерживаемых АНО «Агентство стратегических инициатив» (АСИ).</p>
          </div>
          <div className={about.about__block}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/cot-map.png" alt=""/>
              <p>Наши технологии используют педагоги и ученики по всей России: <strong>98 школ, 3 средних специальных
                учебных заведения и 2 вуза</strong> внедрили наши технологии в свои программы.</p>
          </div>
          <div className={about.about__block}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/cot-school.png" alt=""/>
              <p>Некоторые школы, где уже применяются технологии эффективного обучения центра Advance, вошли в <strong>топ-100
                сильнейших школ страны.</strong></p>
          </div>
          <div className={about.about__block}>
            <img src="https://fs.advance.ru/landing-pages/online/kak_nauchit_rebenka_chitat_2/cot-85.png" alt=""/>
              <p>За 13 лет наши курсы прошли <strong>85 тысяч человек.</strong> Специально разработанная образовательная
                платформа делает обучение удобным и эффективным. </p>
          </div>
        </div>
      </div>

      <CarouselFullscreen
        data={licensesData.map((elem) => (
          <img className={licenses.licenses__imgFullScreen} src={elem.imageSrc} alt={elem.title} />
        ))}
        open={fullScreenState.open}
        selectedSlideIndex={fullScreenState.selectedSlideIndex}
        onClose={() => {
          setFullScreenState({ open: false, selectedSlideIndex: 0 });
        }}
      />
    </section>
  );
};
